<div *ngIf="!isLoading else loading">
    <div *ngIf="detail"
         class="row p-4 payment"
    >
        <div class="col-12 align-text">
            <h2 *ngIf="paymentError"
                style="color: red;"
            >
                {{ 'MODALS.TEXT.TRANSACTION_ERROR' | translate }}
            </h2>
            <h2 *ngIf="paymentInfo.payment_status === 'SUCCESS'"
                class="text-success"
            >
                {{ 'MODALS.TEXT.TRANSACTION_SUCCESS' | translate }}
            </h2>
        </div>

        <div [class.text-success]="!paymentError"
             class="col-4 align-text"
        >
            <i class="bi bi-buildings big_icon"></i>
        </div>
        <div class="col-4 p-text-bg-danger align-text">
            <i *ngIf="!paymentError"
               [class.text-success]="paymentInfo.payment_status === 'SUCCESS'"
               class="bi bi-arrow-right-circle-fill big_icon"
            ></i>
            <i *ngIf="paymentError"
               [class.text-danger]="paymentError"
               class="bi bi-x-circle-fill big_icon"
            ></i>
            <span class="default_icon" style="margin-left: 10px">
				<i *ngIf="paymentInfo.payment_status === 'SUCCESS'"
                   [class.text-success]="paymentInfo.payment_status === 'SUCCESS'"
                   class="bi bi-check2-all big_icon"
                ></i>
			</span>
        </div>
        <div [class.text-success]="paymentInfo.payment_status === 'SUCCESS'"
             class="col-4 align-text"
        >
            <i class="bi bi-buildings big_icon"></i>
        </div>

        <div [class.text-success]="!paymentError"
             class="col-4 align-text"
        >
            <h2>{{ 'MODALS.TEXT.FROM_PROJECT' | translate }} {{ paymentInfo.payer?.name || paymentInfo.payer_guid || ('EMPTY_FIELDS.PROJECT' | translate) }}</h2>
            <h2 *ngIf="!paymentError && paymentInfo.payment_status !== 'SUCCESS'">{{ 'MODALS.TEXT.TRANSACTION_INITIATED' | translate }}</h2>
        </div>
        <div [class.text-success]="paymentInfo.payment_status === 'SUCCESS'"
             class="col-4 align-text"
        >
            <div class="adaptive_total_off">
                <span>{{ 'MODALS.TEXT.TRANSFER_SUM' | translate }}:</span>
                <h1>{{ paymentInfo.total | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}</h1>
            </div>
            <div class="adaptive_icon">
                <i *ngIf="paymentInfo.payment_status === 'SUCCESS'"
                   [class.text-success]="paymentInfo.payment_status === 'SUCCESS'"
                   class="bi bi-check2-all big_icon"
                ></i>
            </div>
        </div>
        <div [class.text-success]="paymentInfo.payment_status === 'SUCCESS'"
             class="col-4 align-text">
            <h2>{{ 'MODALS.TEXT.TO_PROJECT' | translate }} {{ paymentInfo.recipient?.name || paymentInfo.recipient_guid || ('EMPTY_FIELDS.PROJECT' | translate) }}</h2>
        </div>
        <div [class.text-success]="paymentInfo.payment_status === 'SUCCESS'"
             class="col-12 align-text adaptive_total_on"
             style="margin-bottom: 10px">
			<span>{{ 'MODALS.TEXT.TRANSFER_SUM' | translate }}:
				<strong style="font-size: 18px">
					 {{ paymentInfo.total | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
				</strong>
			</span>
        </div>

        <div class="col-12 info">
            <span><strong>{{ 'MODALS.TEXT.PAY_STATUS.STATUS' | translate }}
                :</strong> {{ ('MODALS.TEXT.PAY_STATUS.' + (paymentError ? 'CANCELED' : statusConstructor(paymentInfo))) | translate }}</span><br>
            <span><strong>{{ 'MODALS.TEXT.CREATED_AT_PAY' | translate }}
                :</strong> {{ helper.formatDate(paymentInfo.created_at) }}</span><br>
            <span><strong>{{ 'MODALS.TEXT.PAY_GUID' | translate }}:</strong> {{ paymentInfo.guid }}</span><br>
            <span *ngIf="paymentInfo.updated_at"><strong>{{ 'MODALS.TEXT.UPDATED_AT_PAY' | translate }}
                :</strong> {{ helper.formatDate(paymentInfo.updated_at) }}</span>
            <div *ngIf="multiPaymentInfo && signedMember.length">
                <h2>{{ 'MODALS.TEXT.SIGNERS' | translate }}:</h2>
                <ol>
                    <li *ngFor="let member of signedMember">{{ member.contract_member.member.guid }}</li>
                </ol>
            </div>
        </div>
    </div>

    <div *ngIf="!detail"
         class="payments-table"
    >
        <div (click)="paymentsSlide[i]=!paymentsSlide[i]"
             *ngFor="let item of payments; let i = index"
             class="payments-table-item"
        >
            <div class="item-head p-2 border {{item.payment_status === 'SUCCESS' ? 'border-success' : 'border-warning'}}"
                 style="border-radius: 15px;"
            >
                <div>
                    <i *ngIf="item.payment_status === 'SUCCESS'"
                       class="bi bi-check2-all text-success"
                    ></i>
                    <i *ngIf="['NEW', 'PROMISED', 'EXECUTION', 'APPROVED'].includes(item.payment_status)"
                       class="bi bi-check2 text-warning"
                    ></i>
                    <i *ngIf="!['SUCCESS', 'NEW', 'PROMISED', 'EXECUTION', 'APPROVED'].includes(item.payment_status)"
                       class="bi bi-lock-fill text-danger"
                    ></i>

                    <ng-container *ngIf="item.payer_type === 'BANK' && item.recipient_type === 'PROJECT'">
                        <label class="{{item.payment_status === 'SUCCESS' ? ' text-success' : ' text-warning'}}">
                            <i class="bi bi-arrow-right"></i>
                            {{ 'MODALS.TEXT.PAY_TYPE.REPLENISHMENT' | translate }}
                        </label><br>
                    </ng-container>
                    <ng-container *ngIf="item.payer_type === 'PROJECT' && item.recipient_type === 'BANK'">
                        <label class="{{item.payment_status === 'SUCCESS' ? ' text-success' : ' text-warning'}}">
                            <i class="bi bi-arrow-left"></i>
                            {{ 'MODALS.TEXT.PAY_TYPE.CONCLUSION' | translate }}
                        </label><br>
                    </ng-container>
                    <ng-container *ngIf="item.payer_type === 'PROJECT' && item.recipient_type === 'PROJECT'">
                        <label *ngIf="item.payer && item.recipient && item.payer.guid === item.recipient.guid"
                               class="{{item.payment_status === 'SUCCESS' ? ' text-success' : ' text-warning'}}">
                            <i class="bi bi-arrow-left"></i>
                            {{ 'MODALS.TEXT.PAY_TYPE.TRANSFER' | translate }}<br>
                        </label>
                        <label *ngIf="item.payer &&
                                      item.recipient &&
                                      item.payer.guid !== item.recipient.guid &&
                                      ['SUCCESS', 'NEW', 'PROMISED', 'EXECUTION', 'APPROVED'].includes(item.payment_status)"
                               class="{{item.payment_status === 'SUCCESS' ? ' text-success' : ' text-warning'}}">
                            <i class="{{walletProjectGuid === item.payer_guid ? 'bi bi-arrow-right' : 'bi bi-arrow-left'}}"
                               title="{{ (walletProjectGuid === item.payer_guid ? 'MODALS.TEXT.OUT_TRANSFER' : 'MODALS.TEXT.IN_TRANSFER') | translate }}"></i>
                            {{ 'MODALS.TEXT.PAY_TYPE.ONLY_TRANSFER' | translate }}
                        </label>
                        <label *ngIf="!['SUCCESS', 'NEW', 'PROMISED', 'EXECUTION', 'APPROVED'].includes(item.payment_status)"
                               class="text-danger">
                            <i class="{{walletProjectGuid === item.payer_guid ? 'bi bi-arrow-right' : 'bi bi-arrow-left'}}"
                               title="{{ (walletProjectGuid === item.payer_guid ? 'MODALS.TEXT.OUT_TRANSFER' : 'MODALS.TEXT.IN_TRANSFER') | translate }}"></i>
                            {{ 'MODALS.TEXT.PAY_TYPE.CANCEL_TRANSFER' | translate }}
                        </label><br>
                    </ng-container>

                    <strong style="margin-left: 5px">{{ 'MODALS.TEXT.PAY' | translate }} {{ item.total | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}</strong>
                </div>
                <div class="text-break">
                    <small>{{ 'MODALS.TEXT.CREATED_AT_PAY' | translate }}
                        : {{ item.created_at | date:'HH:mm dd.MM.yyyy' }}</small><br>
                    <small *ngIf="item.payment_status === 'SUCCESS' && item.execution_date">
                        {{ 'MODALS.TEXT.SUCCESS_AT_PAY' | translate }}
                        : {{ item.execution_date | date:'HH:mm dd.MM.yyyy' }}
                    </small>
                </div>
            </div>
            <div *ngIf="paymentsSlide[i]"
                 class="item-slide"
            >
                <small><strong>{{ 'MODALS.TEXT.CREATED_AT_PAY' | translate }}
                    : </strong>{{ item.created_at | date:'HH:mm dd.MM.yyyy' }}</small><br>
                <small><strong>{{ 'MODALS.TEXT.PAY_STATUS.STATUS' | translate }}
                    : </strong>{{ ('MODALS.TEXT.PAY_STATUS.' + statusConstructor(item)) | translate }}</small><br>
                <small><strong>{{ 'MODALS.TEXT.PAY_GUID' | translate }}: </strong>{{ item.guid }}</small><br>
                <small><strong>{{ 'MODALS.TEXT.PAYER' | translate }}: </strong>{{ item.payer_type }}</small><br>
                <small><strong>{{ 'MODALS.TEXT.RECIPIENT' | translate }}: </strong>{{ item.recipient_type }}</small><br>
                <small *ngIf="item.execution_date"><strong>{{ 'MODALS.TEXT.SUCCESS_AT_PAY' | translate }}: </strong>
                    {{ item.execution_date | date:'HH:mm dd.MM.yyyy' }}</small>
            </div>
        </div>
    </div>
    <div *ngIf="payments && !detail && !payments.length">
        {{ 'EMPTY_LISTS.PAYMENT_HISTORY' | translate }}
    </div>
</div>

<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>
